import React from "react";
import { FaFire, FaBox, FaTree, FaCross } from "react-icons/fa";

import { Link } from "react-router-dom";


import "./Home.css";

const Home = () => {
  const services = [
    {
      title: "Cremation",
      description: "Dignified farewell with respectful cremation services.",
      image: "images/1-2 (1).jpg",
    },
    {
      title: "Ashes Return",
      description: "Ashes can be returned in an elegant urn of your choice.",
      image: "images/main-qimg-44bd09e055aef86d6254ddcd433f0923-lq.jpg",
    },
    {
      title: "Memory Tree",
      description: "Plant ashes as a tree to keep memories alive forever.",
      image: "images/images.jpg",
    },
    {
      title: "Burial",
      description: "Traditional and peaceful pet burial services.",
      image: "images/b.jpg",
    },
  ];

  const servicesData = [
    { icon: <FaFire />, title: "Cremation", description: "Dignified farewell with respectful cremation services." },
    { icon: <FaBox />, title: "Ashes Return", description: "Ashes can be returned in an elegant urn of your choice." },
    { icon: <FaTree />, title: "Memory Tree", description: "Plant ashes as a tree to keep memories alive forever." },
    { icon: <FaCross />, title: "Burial", description: "Traditional and peaceful pet burial services." },
  ];
  
  return (
    <>
    <div className="hero-section">
      {/* Left Content */}
      <div className="content">
        <h1> <span className="pet-heading-name">PET</span> CREMATION & BURIALS</h1>
        <p>
        Providing compassionate and dignified pet cremation and burial services to honor your beloved companions."
        </p>
       <Link to="/Contact" className="button-home"><button className="contact-btn">Get in Touch</button></Link>
       <Link to="/Donate" className="button-home"><button className="contact-btn">Donate Now</button></Link>

      
        

        <div className="precautions">
          <span>Our standard precautions</span>
          <div className="icons">
            🏥 🧍‍♂️💳
          </div>
        </div>

        <div className="emergency-box">
          <span className="attention">24/7 Attention</span>
          <span className="call">Call Emergency</span>
          <span className="number">6304692989 OR
          9160383791</span>
        </div>
      </div>

      {/* Right Image */}
      <div className="image-container">
        <img src="images/costs-of-pet-cremation (1).jpg" alt="Pet Care" />
        <div className="discount">24/7  <br /> Services</div>
      </div>
    </div>
    <div>
    <div className="services-section">
      <h1 className="section-title">Our Services</h1>
      <div className="services-container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <img src={service.image} alt={service.title} className="service-image" />
            <h2 className="service-title">{service.title}</h2>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
    </div>
    <div>
    <div className="banner">
      <div className="overlay"></div>
      <div className="banner-content">
        <p className="quote">
          "The Bitterest Tears Shed Over Graves <br />
          Are for Words Left Unsaid and Deeds Left Undone."
        </p>
        <p className="author">– Harriet Beecher Stowe</p>
      </div>
    </div>
    </div>


   

    <div className="pet-cremation-section">
      
      <div className="pet-cremation-container">
        
        {/* Left - Content */}
        <div className="pet-content">

          <h2 className="pet-title">About <span>Us</span></h2>
          <p >
            Providing compassionate and dignified pet cremation and burial services to honor your beloved companions. 
            We understand that pets are more than just animals; they are family, confidants, and the purest source of unconditional love.
          </p>
          <p className="about-some-para">
            The loss of a pet leaves an irreplaceable void, but their love and memories live forever in our hearts. 
            Whether it’s a joyful bark, a gentle purr, or a comforting presence, their essence remains with us, shaping our lives in ways words cannot describe.
          </p>
  
          <ul >
            <li >🐾 Personalized pet cremation & burial services</li>
            <li>🐾 Memorial options to celebrate your pet’s life</li>
            <li>🐾 A place to say your final goodbye with love & dignity</li>
          </ul>
        </div>

        {/* Right - Image */}
        <div className="pet-image">
          <img src='images/istockphoto-1516239450-612x612.jpg' alt="Pet Memorial" />
        </div>
      </div>
    </div>
    <div className="contact-container">
      {/* Top Section with Pets */}
      <div className="contact-header">
        <img src='images/blog-details-shape-1.png' alt="Pets" className="pets-banner" />
     
      </div>

      {/* Footer Section */}
      <div className="contact-footer">
        <div className="footer-column" >
          <h3 >Explore</h3>
          <ul >
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/services">Services</a></li>
       
          </ul>
        </div>
        <div className="footer-column">
          <h3>Phone</h3>
          <ul>
          <p className="phone-number">6304692989
           </p>
          <p className="phone-number">
          9160383791 </p>
          </ul>
        </div>
        <div className="footer-column">
          <h3>Contact</h3>
          <p>41-30/1-49,Krishna Lanka,</p>
          <p>Vijayawada,pin :520013</p>
          <p>Email: petburialvijayawada@gmail.com</p>
        
        </div>
        <div className="footer-column">
          <h3>About</h3>
          <p>
            We provide compassionate pet cremation and burial services, ensuring a dignified farewell for your beloved companions.
          </p>
          <div className="email-subscribe">
            <input type="email" placeholder="Enter your email" />
            <button>→</button>
          </div>
        </div>
      </div>
    </div>

    <div className="custom-why-choose">
      <h2>WHY CHOOSE US</h2>
      <p className="custom-subtitle">We ensure a dignified farewell with love and care.</p>
      <div className="custom-service-cards">
        {servicesData.map((service, index) => (
          <div className="custom-service-card" key={index}>
            <div className="custom-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </div>


   



    </>
  );
};

export default Home;
